import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const CancelPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 bg-red-500/10 border-2 border-red-500/30 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-red-400" />
        </div>
        <h1 className="text-3xl font-black text-white mb-2">Payment cancelled</h1>
        <p className="text-gray-400 mb-8">No worries — nothing was charged. You can try again whenever you're ready.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="bg-green-500 hover:bg-green-400 text-gray-950 font-bold px-6 py-3 rounded-xl transition-colors"
          >
            Try again
          </button>
          <Link to="/pricing" className="bg-gray-800 hover:bg-gray-700 text-white px-6 py-3 rounded-xl transition-colors">
            View plans
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CancelPage;
